import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledBadge = styled(Ds.Badge)`
    background-color: var(--ds-color-cloud);
`;
